import React, { useState, useCallback } from 'react';
import { Dialog } from '@framework-controls/core';
import css from './ErrorMessage.module.scss';
import SVPButton from '../SVPButtons/SVPButton';
import { IconRemove, IconRemoveAudi } from 'src/content/icons';
import { strings } from 'src/localization';

export interface IProps {
    headerMsg: string;
    errorMsg?: string;
    customError?: JSX.Element;
    primaryBtnMessage: string;
    secondaryBtnMessage: string;
    primaryArrow?: boolean;
    primaryHandler: (event: any) => void;
    secondaryHandler: (event: any) => void;
    closeHandler: (event: any) => void;
}

const ErrorMessage = (props: IProps) => {
    const [menuOpenFlag, setMenuOpenFlag] = useState(true);
    const [noPrimArrow] = useState(props.primaryArrow ? false: true);

    // Close the error message modal and process the passed in closeHandler
    const closeHandler = useCallback((e) => {
        setMenuOpenFlag(false);
        props.closeHandler(e);
    }, [props.closeHandler]);

    // Audi only: Enter/Space on the close wrapper runs the same close as onClick.
    const closeKeyHandler = useCallback((e: React.KeyboardEvent<HTMLElement>) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            closeHandler(e);
        }
    }, [closeHandler]);

    // let customButtons: IFormButton[] = [];
    // customButtons = [
    //     { label: props.secondaryBtnMessage, value: '2', color: 'secondary', variant: 'secondaryBtnAlt' },
    //     { label: props.primaryBtnMessage, value: '1', color: 'primary', variant: 'primaryBtnAlt' },
    // ];

    // const onCustomClick = useCallback((event: React.MouseEvent<HTMLElement>, id: any) => {
    const onCustomClick = useCallback((e: any, id: any) => {
        switch (id) {
            case '1':
                props.primaryHandler(e);
                break;

            case '2':
                props.secondaryHandler(e);
                break;

            default:
                break;
        }
    }, [props.primaryHandler, props.secondaryHandler]);
    let SecondaryButton: JSX.Element | null = null;
    if (props.secondaryBtnMessage) {
        SecondaryButton = (<SVPButton
            id='secondary'
            handler={(e: any) => onCustomClick(e, '2')}
            message={props.secondaryBtnMessage}
            noArrow
            variant={'secondaryBtnAlt'}
        />);
    }

    // No theme prop reaches this shared component, so read the theme-${theme} class App.tsx puts on <html>.
    const isAudi = document.documentElement.classList.contains('theme-audi');

    return (
        <div>
            <Dialog
                cssClasses={{
                    content: css.content,
                    paper: css.paper,
                    header: css.LightBoxHeader,
                }}
                isOpen={menuOpenFlag}
                anchorOrigin={{
                    vertical: 'top',
                }}
                header={props.headerMsg}
                hideSave={true}
                hideCancel={true}
                disableUpperCase={true}
                onCancel={closeHandler}
                onBackDropClick={closeHandler}
                width='full'
                // customButtons={customButtons}
                onCustomClicked={onCustomClick}
            >
                <div className={css.headerbox}>
                    {props.headerMsg}
                    {/* Audi: handler on the 40x40 wrapper (RemoveAudi.svg is 16x16); others match master. */}
                    {isAudi ?
                        <div className={css.headerIcon} onClick={closeHandler}
                            onKeyDown={closeKeyHandler}
                            role='button'
                            tabIndex={0}
                            aria-label={strings.Close}
                            data-testid='ErrorMessage-closeBtn'>
                            <IconRemoveAudi id='closeBtn'/>
                        </div> :
                        <div className={css.headerIcon}>
                            <IconRemove id='closeBtn' onClick={closeHandler}/>
                        </div>}
                </div>
                {props.customError ? props.customError : props.errorMsg}
                <div className={css.footer}>
                    <hr className={css.horizLine}/>
                    <div className={css.btnArea}>
                        {SecondaryButton}
                        <SVPButton
                            id='primary'
                            handler={(e: any) => onCustomClick(e, '1')}
                            message={props.primaryBtnMessage}
                            variant={'primaryBtnAlt'}
                            noArrow={noPrimArrow}/>
                    </div>
                </div>
            </Dialog>
        </div>
    );
};

export default ErrorMessage;